// extracted by mini-css-extract-plugin
module.exports = {"footerSelectContainer":"WidgetRevenuePerHour_footerSelectContainer__11wza"};